import { render, staticRenderFns } from "./OrderableAddProductBundlePreview.vue?vue&type=template&id=577fa772&"
import script from "./OrderableAddProductBundlePreview.vue?vue&type=script&lang=ts&"
export * from "./OrderableAddProductBundlePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports